import { render, staticRenderFns } from "./clickViewInfo.vue?vue&type=template&id=2a6b9091&scoped=true&"
import script from "./clickViewInfo.vue?vue&type=script&lang=js&"
export * from "./clickViewInfo.vue?vue&type=script&lang=js&"
import style0 from "./clickViewInfo.vue?vue&type=style&index=0&id=2a6b9091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b9091",
  null
  
)

export default component.exports